export default "__VITE_ASSET__OMCQtU$Y__"